import Papa from 'papaparse'

const EXCEL_EXTENSIONS = ['.xlsx', '.xls'];

const isExcelFile = (fileName = '') => {
    const lower = fileName.toLowerCase();
    return EXCEL_EXTENSIONS.some((ext) => lower.endsWith(ext));
};

const CsvFileInput = ({ onFileLoad }) => {
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (isExcelFile(file.name)) {
            onFileLoad({ type: 'excel', file, rows: [] });
            return;
        }

        Papa.parse(file, {
            complete: (result) => {
                onFileLoad({ type: 'csv', file, rows: result.data });
            },
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
        });
    };

    return (
        <div>
            <input type="file" accept='.xlsx,.xls,.csv' onChange={handleFileChange} />
        </div>
    );
};

export default CsvFileInput;
